import styled from 'styled-components'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'
import Skeleton from 'react-loading-skeleton'
import RenderIf from 'src/components/common/RenderIf'
import { Bridge } from 'src/utils/bridge'

const MixedHtmlData = ({ html = '' }: { html?: string }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const [mixedData, setMixedData] = useState<string>('')

  const handleUrlClick = useCallback((element: any) => {
    Bridge.handleReqExternalOpenUrl(element.target.dataset.url)
  }, [])

  useEffect(() => {
    const replaceATag = (url: string) =>
      `<img alt="url image" src="${url}" onerror="this.style.display='none';" style="width: calc(100% + 40px); height: auto; display: block; position: relative; left: -20px;" /><span>[이미지 바로가기]</span></span><span data-url="${url}" style="color: blue; text-decoration: underline; cursor: pointer; width: fit-content;">${url}</span>`
    const urlPattern = /https?:\/\/[^\s)]+/g

    const handleReplaceStr = (text: string) => {
      return text
        ?.replace(urlPattern, (url) => replaceATag(url))
        ?.replace(/\\r\\n|\\n|\\r/gm, '\n')
        ?.replace(/\s+$/gm, '<br/>')
        ?.trim()
    }

    setMixedData(handleReplaceStr(html))
  }, [html])

  useEffect(() => {
    const container = containerRef.current
    if (container) {
      const spans = container.querySelectorAll('span[data-url]')
      spans.forEach((span) => {
        span.addEventListener('click', handleUrlClick)
      })

      return () => {
        spans.forEach((span) => {
          span.removeEventListener('click', handleUrlClick)
        })
      }
    }
  }, [mixedData, handleUrlClick])

  return (
    <React.Fragment>
      <S.ExceptionText ref={containerRef} dangerouslySetInnerHTML={{ __html: mixedData }} />
      <RenderIf when={mixedData === ''}>
        <Skeleton count={5} style={{ margin: '5px 0' }} />
      </RenderIf>
    </React.Fragment>
  )
}

export default MixedHtmlData

const S = {
  ExceptionText: styled.p`
    ${Noto_body2_r14};
    color: var(--black-70);
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
}
